module.exports = __webpack_public_path__ + "components/breakheader/background/background--2-109112ad295eb806bb6efc72e357e4dd.jpg";